module.exports = __webpack_public_path__ + "static/img/jishuyoushi-bg.495c9bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jishuyoushi-bg.png
// module id = yWH1
// module chunks = 2